import packageJson from '../../package.json';
const CLIENT_SDK_HEADER = 'Client-SDK';
const { version } = packageJson;
export function getHttpHeaders(additionalHttpHeaders) {
    const clientSDKHeaderValues = Object.assign(Object.assign({}, additionalHttpHeaders === null || additionalHttpHeaders === void 0 ? void 0 : additionalHttpHeaders[CLIENT_SDK_HEADER]), { ANSWERS_HEADLESS: version });
    return Object.assign(Object.assign({}, additionalHttpHeaders), { [CLIENT_SDK_HEADER]: clientSDKHeaderValues });
}
//# sourceMappingURL=client-sdk-utils.js.map